import React, { useState } from 'react';
import type { PurchasableModule } from '../hooks/usePurchases';

interface PurchaseModalProps {
  isOpen: boolean;
  moduleName: string;
  moduleId: PurchasableModule;
  moduleEmoji: string;
  moduleColor: string;
  onPurchase: (moduleId: PurchasableModule) => Promise<boolean>;
  onClose: () => void;
}

const moduleDescriptions: Record<PurchasableModule, string> = {
  hard: "Des questions et actions plus intenses pour les soirées les plus folles !",
  roulette: "La roulette décide pour toi ! Pose le téléphone au centre et laisse le hasard choisir.",
  coquin: "Le mode pour les soirées coquines entre adultes consentants... 🌶️",
};

export default function PurchaseModal({
  isOpen,
  moduleName,
  moduleId,
  moduleEmoji,
  moduleColor,
  onPurchase,
  onClose,
}: PurchaseModalProps) {
  const [purchasing, setPurchasing] = useState(false);

  if (!isOpen) return null;

  const handlePurchase = async () => {
    setPurchasing(true);
    try {
      const success = await onPurchase(moduleId);
      if (success) {
        onClose();
      }
    } finally {
      setPurchasing(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-sm rounded-3xl bg-gradient-to-b from-gray-800 to-gray-900 p-6 shadow-2xl animate-slide-up">
        {/* Emoji */}
        <div className="text-center text-5xl mb-4">{moduleEmoji}</div>

        {/* Title */}
        <h3 className="text-center font-display font-bold text-2xl text-white mb-2">
          Débloquer {moduleName}
        </h3>

        {/* Description */}
        <p className="text-center text-white/60 font-body text-sm mb-6 px-2">
          {moduleDescriptions[moduleId]}
        </p>

        {/* Price */}
        <div className="glass rounded-2xl p-4 mb-6 text-center">
          <span className="font-display font-bold text-3xl text-white">1,99 €</span>
          <p className="text-white/40 text-xs mt-1">Achat unique • Accès permanent</p>
        </div>

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={handlePurchase}
            disabled={purchasing}
            className={`w-full py-3.5 rounded-2xl ${moduleColor} text-white font-display font-bold text-base btn-press disabled:opacity-50 transition-opacity`}
          >
            {purchasing ? 'Achat en cours...' : 'Acheter maintenant'}
          </button>
          <button
            onClick={onClose}
            className="w-full py-3 rounded-2xl bg-white/10 text-white/60 font-display font-medium text-sm btn-press"
          >
            Non merci
          </button>
        </div>
      </div>
    </div>
  );
}
